import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

function TitleBoxContent(props) {
    return (
        <>
            <PC>
                <section className="pc-title-box-context">
                    <div className="background">
                        <div className="layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                        </div>
                    </div>
                </section>
            </PC>

            <Notebook>
                <section className="pc-title-box-context">
                    <div className="background">
                        <div className="layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                        </div>
                    </div>
                </section>
            </Notebook>

            <Tablet>
                <section className="mobile-title-box-context">
                    <div className="background">
                        <div className="layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                        </div>
                    </div>
                </section>
            </Tablet>

            <Mobile>
                <section className="mobile-title-box-context">
                    <div className="background">
                        <div className="layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                        </div>
                    </div>
                </section>
            </Mobile>
        </>
    )
}

export default TitleBoxContent
